<template>
  <v-dialog
    width="500"
    v-bind="$attrs"
    persistent
    v-on="$listeners"
  >
    <v-card>
      <v-card-title>
        تایید
      </v-card-title>
      <v-card-text>{{ modal && modal.data && modal.data.title }}</v-card-text>
      <v-card-actions>
        <v-btn
          color="green darken-1"
          text
          @click="modal.modal.close(false)"
        >
          انصراف
        </v-btn>
        <v-btn
          color="P1"
          dark
          @click="modal.modal.close(true)"
        >
          تایید
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "AppConfirmDialog",
  props: ["modal"],
}

 </script>
<style>
.modal {
  height: 360px !important;
}
</style>